<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #ac8400">FAQ View</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #f2f2f2">
      <router-link to="/dashboard">Dashboard</router-link>/ <b>Marketing</b> /
      <b>FAQ</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- TBA -->
        <div class="card text-left">
          <div class="card-body">
            <router-link
              to="/faq/new"
              type="button"
              class="btn btn-primary btn-rounded mb-2 mb-4"
            >
              New FAQ
            </router-link>

            <h4 class="card-title mb-3">FAQ</h4>

            <!-- Active -->
            <div class="table-responsive">
              <table
                id="faq_active_tbl"
                class="display table table-striped table-bordered"
                style="width: 100%; text-align: center"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Questions</th>
                    <th>Answers</th>
                    <th>Type</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(faq, index) in activeFaqs" v-bind:key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ faq.question }}</td>
                    <td><span v-html="faq.answer"></span></td>
                    <td>
                      <span v-if="faq.type == 1">General</span>
                      <span v-else>Loyalty Points</span>
                    </td>

                    <td>
                      <span v-if="faq.active == 0">Inactive</span>
                      <span v-else>Active</span>
                    </td>

                    <td>
                      <router-link
                        :to="redirectFaq(faq.id)"
                        type="button"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78be20; border-color: #78be20"
                        >Edit Details</router-link
                      >

                      <button
                        class="btn btn-danger btn-rounded btn-block"
                        @click="updateStatus(faq.id, 0)"
                      >
                        Deactivate
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <hr />

            <h4 class="card-title mb-3">Inactive FAQ</h4>
            <p>The table below shows the list of inactive FAQs.</p>

            <!-- Inactive -->
            <div class="table-responsive">
              <table
                id="faq_inactive_tbl"
                class="display table table-striped table-bordered"
                style="width: 100%; text-align: center"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Questions</th>
                    <th>Answers</th>
                    <th>Type</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(faq, index) in inactiveFaqs" v-bind:key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ faq.question }}</td>
                    <td><span v-html="faq.answer"></span></td>
                    <td>
                      <span v-if="faq.type == 1">General</span>
                      <span v-else>Loyalty Points</span>
                    </td>

                    <td>
                      <span v-if="faq.active == 0">Inactive</span>
                      <span v-else>Active</span>
                    </td>

                    <td>
                      <router-link
                        :to="redirectFaq(faq.id)"
                        type="button"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78be20; border-color: #78be20"
                        >Edit Details</router-link
                      >

                      <button
                        class="btn btn-primary btn-rounded btn-block"
                        @click="updateStatus(faq.id, 1)"
                      >
                        Active
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "faq_view",
  components: {},

  data() {
    return {
      activeFaqs: [],
      inactiveFaqs: [],
    };
  },

  methods: {
    loadInactiveFaq() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/faq/status/0", {
            headers: {
              Authorization: "Bearer " + token,
            },
          })
          .then((res) => {
            this.inactiveFaqs = res.data.faqs;
          })
          .then(function () {
            $("#faq_inactive_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: [
                {
                  extend: "excelHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4],
                  },
                },
                {
                  extend: "pdfHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4],
                  },
                },
              ],
            });
          });
      }
    },

    loadActiveFaq() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/faq/status/1", {
            headers: {
              Authorization: "Bearer " + token,
            },
          })
          .then((res) => {
            this.activeFaqs = res.data.faqs;
          })
          .then(function () {
            $("#faq_active_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: [
                {
                  extend: "excelHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4],
                  },
                },
                {
                  extend: "pdfHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4],
                  },
                },
              ],
            });
          });
      }
    },

    updateStatus(id, status) {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        swal({
          icon: "warning",
          text: "Are you sure?",
          buttons: ["Cancel", "Yes"],
        }).then((confirm) => {
          if (confirm) {
            axios
              .post(
                axios.lpsURL + "/faq/status",
                {
                  id: id,
                  status: status,
                },
                {
                  headers: {
                    Authorization: "Bearer " + token,
                  },
                }
              )
              .then((res) => {
                if (res.data.success) {
                  swal({
                    icon: "success",
                    text: res.data.message,
                  }).then((val) => {
                    this.loadData();
                  });
                } else {
                  swal({
                    icon: "warning",
                    text: res.data.message,
                  });
                }
              });
          }
        });
      }
    },

    loadData() {
      this.destroyDatatable();
      this.loadActiveFaq();
      this.loadInactiveFaq();
    },

    destroyDatatable() {
      $("#faq_active_tbl").DataTable().destroy();
      $("#faq_inactive_tbl").DataTable().destroy();
    },

    redirectFaq(id) {
      return "/faq/update/" + id;
    },
  },

  mounted() {
    this.loadData();
  },
};
</script>
